import { Link } from "react-router-dom";
import { routes } from "routes";
import rgLogo from "components/icons/RGLogo.svg";
import "./RGLogo.scss";

export const RGLogo = () => {
  return (
    <Link to={routes.home()} className="mainLogo" title="Back to home page">
      <img src={rgLogo} alt="Red GIFs" />
    </Link>
  );
};
